import { useQuery } from 'react-query';

import { getAdministrationAccounts } from 'RestAPIs/admin';
import { Account } from '../../../../types';
import dayjs from 'dayjs';

export const getBackOnlyValidAccounts = (accounts: Account[]) =>
  accounts.filter((acc: Account) => {
    return (
      dayjs(acc.valid.from) <= dayjs(new Date()) &&
      dayjs(acc.valid.to) >= dayjs(new Date())
    );
  });

export const useGetAccounts = () => {
  const { data, isFetching } = useQuery({
    queryFn: getAdministrationAccounts,
    queryKey: ['accounts', 'list']
  });

  return { data: data ?? [], isFetching };
};
